import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { FiX, FiHome, FiTool, FiClock } from 'react-icons/fi'
import ServiceProviderAppication from './ServiceProviderAppication'
import { getUserProfile } from '../../../api/user/account'
import { LIST_PROPERTY_PATH } from '../../../features/dashboards'
import { PROPERTY_BASE } from '../../../features/property-owner/paths'
import './UpdateAccount.css'

const UpdateAccount = () => {
    const { t } = useTranslation()
    const location = useLocation()
    const navigate = useNavigate()
    const [UpdatePanel, isUpdatePanel] = useState(false)
    const [isOwner, setIsOwner] = useState(false)

    const toggleUpdatePanel = () => {
        isUpdatePanel(!UpdatePanel)
    }

    // Auto-trigger the provider application based on onboarding intent state
    useEffect(() => {
        if (location.state?.openServiceModal) {
            isUpdatePanel(true)
        }
    }, [location.state])

    // Check the logged-in user's current account type
    useEffect(() => {
        const loadProfile = async () => {
            try {
                const response = await getUserProfile()
                if (response.success && response.user) {
                    setIsOwner(response.user.propertyCount > 0 || response.user.is_property_owner === 'yes')
                }
            } catch (error) {
                console.error('Failed to load profile:', error)
            }
        }
        loadProfile()
    }, [])

    // No application: anyone can list a property. Identity is verified with the
    // first listing, from the property dashboard.
    const handleBecomeOwner = () => {
        navigate(isOwner ? PROPERTY_BASE : LIST_PROPERTY_PATH)
    }

    return (
        <div className="update-account-page">
            <div className="ab-page-bg" aria-hidden="true">
                <div className="ab-blob ab-blob-1" />
                <div className="ab-blob ab-blob-2" />
                <div className="ab-blob ab-blob-3" />
            </div>

            <div className='container Update-account-container'>
                {UpdatePanel && <ServiceProviderAppication toggleUpdatePanel={toggleUpdatePanel} />}

                <header className="update-account-hero">
                    <div className="update-hero-icon">
                        <i className="fa fa-user-plus" aria-hidden="true" />
                    </div>
                    <div>
                        <h1 className="update-hero-title">{t('update_account.title')}</h1>
                        <p className="update-hero-subtitle">
                            {t('update_account.subtitle')}
                        </p>
                    </div>
                </header>

                <div className='update-account-options'>
                    {/* option 1 — Property Owner / Agent Application */}
                    <div className={`account-option option-building ${isOwner ? 'already-active' : ''}`} onClick={handleBecomeOwner} role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter') handleBecomeOwner(); }}>
                        <span className="update-option-icon"><i className='fa fa-building' aria-hidden="true" /></span>
                        <h2>{t('update_account.become_property_owner')}</h2>
                        <p>
                            {t('update_account.become_property_owner_desc')}
                        </p>
                        <span className="update-option-arrow">
                            <i className="fa fa-arrow-right" aria-hidden="true" />
                        </span>
                        {isOwner && (
                            <span className="update-option-badge">
                                <i className="fa fa-check" aria-hidden="true" /> {t('update_account.already_owner')}
                            </span>
                        )}
                    </div>

                    {/* option 2 — Service Provider */}
                    <div className='account-option option-services' onClick={toggleUpdatePanel} role="button" tabIndex={0}>
                        <span className="update-option-icon"><i className='fa fa-gear' aria-hidden="true" /></span>
                        <h2>{t('update_account.become_service_provider')}</h2>
                        <p>
                            {t('update_account.become_service_provider_desc')}
                        </p>
                        <span className="update-option-arrow"><i className="fa fa-arrow-right" aria-hidden="true" /></span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UpdateAccount
